<template>
  <TText
    variant="semibold"
    color="text-white"
    size="sm"
    classes="uppercase mb-2"
  >
    {{ t(section.title) }}
  </TText>
  <ul class="mb-12 xl:mb-0">
    <li v-for="(item, item_index) in section.links" :key="item_index">
      <span
        v-if="'action' in item"
        role="button"
        tabindex="0"
        class="text-base leading-6 text-gray-400 hover:text-white py-2 block transition ease-in-out duration-300 cursor-pointer"
        @click="runAction(item.id)"
        @keydown.enter="runAction(item.id)"
        >{{ t(item.name) }}
      </span>
      <a
        v-else-if="'href' in item"
        :href="item.href"
        :rel="item.rel"
        :target="item.target"
        class="text-base leading-6 text-gray-400 hover:text-white py-2 block transition ease-in-out duration-300"
        >{{ t(item.name) }}</a
      >
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { FooterLinksSection } from '../entities/MenuFooter'
import { runAction } from '../composables/useMenuFooterActions'

interface MenuFooterLinkSection_Props {
  section: FooterLinksSection
}

defineProps<MenuFooterLinkSection_Props>()
</script>
